module.exports = __webpack_public_path__ + "img/sg.208df411.png";